//
//
//
//
//
//
//
//
//
//
//
//

import {getWatermark} from '@/api/watermark/index';

export default {
  data() {
    return {
      item:{},
      ids:'',
      h:100,
      w:375,
      tags:[],
    };
  },
  methods: {
    getWatermark(){
      let param = {id:this.ids}
      getWatermark(param).then((res) => {
        this.item = res.data;
        this.tags = res.data.tags;
        this.width = res.data.imageWidth;
        this.height = res.data.imageHeight;
        /*this.w = document.body.clientWidth;*/
        this.h = (this.w/this.width)*this.height;
        let newTime = new Date().getTime();
        // 对结束时间进行处理渲染到页面

        var t = this.item.activityTime;
        t = t.replace(/-/g,'/');
        let endTime = new Date(t).getTime();
        let obj = null;
        // 如果活动未结束，对时间进行处理
        if (endTime - newTime > 0) {
          let time = (endTime - newTime) / 1000;
          // 获取天、时、分、秒
          let day = parseInt(time / (60 * 60 * 24));
          let hou = parseInt(time % (60 * 60 * 24) / 3600);
          let min = parseInt(time % (60 * 60 * 24) % 3600 / 60);
          obj = {
            day: day,
            hou: hou,
            min: min,
          };
          for(var i = 0;i<this.tags.length;i++){
            if(this.tags[i].position_x != 0 && this.tags[i].position_y != 0){
              this.tags[i].left = (this.w/this.width) * this.tags[i].position_x;
              this.tags[i].top = (this.w/this.width) * this.tags[i].position_y;
              if(this.tags[i].type == 3){
                if(obj.day > 9){
                  this.tags[i].img_width = (this.w/this.width) * (this.tags[i].width/2);
                  this.tags[i].img_height = (this.w/this.width) * (this.tags[i].height);
                  var s =   obj.day.toString().substr(0,1);
                  var g =   obj.day.toString().substr(1,2);
                  this.tags[i].img_path = 'static/images/watermark/'+this.item.tagId+'/'+s+'@2x.png';
                  this.tags[i].img_path2 = 'static/images/watermark/'+this.item.tagId+'/'+g+'@2x.png';
                }else{
                  this.tags[i].img_width = (this.w/this.width) * this.tags[i].width;
                  this.tags[i].img_height = (this.w/this.width) * this.tags[i].height;
                  this.tags[i].img_path2 = 'static/images/watermark/'+this.item.tagId+'/'+obj.day+'@2x.png';
                }
              }else if(this.tags[i].type == 4){
                this.tags[i].img_width = (this.w/this.width) * (this.tags[i].width/2);
                this.tags[i].img_height = (this.w/this.width) * (this.tags[i].height);
                if(obj.hou > 9){
                  var s =   obj.hou.toString().substr(0,1);
                  var g =   obj.hou.toString().substr(1,2);
                  this.tags[i].img_path = 'static/images/watermark/'+this.item.tagId+'/'+s+'@2x.png';
                  this.tags[i].img_path2 = 'static/images/watermark/'+this.item.tagId+'/'+g+'@2x.png';

                }else{
                  this.tags[i].img_path = 'static/images/watermark/'+this.item.tagId+'/0@2x.png';
                  this.tags[i].img_path2 = 'static/images/watermark/'+this.item.tagId+'/'+obj.hou+'@2x.png';
                }
              }else if(this.tags[i].type == 5){
                this.tags[i].img_width = (this.w/this.width) * (this.tags[i].width/2);
                this.tags[i].img_height = (this.w/this.width) * (this.tags[i].height);
                if(obj.min > 9){
                  var s =   obj.min.toString().substr(0,1);
                  var g =   obj.min.toString().substr(1,2);
                  this.tags[i].img_path = 'static/images/watermark/'+this.item.tagId+'/'+s+'@2x.png';
                  this.tags[i].img_path2 = 'static/images/watermark/'+this.item.tagId+'/'+g+'@2x.png';
                }else{
                  this.tags[i].img_path = 'static/images/watermark/'+this.item.tagId+'/0@2x.png';
                  this.tags[i].img_path2 = 'static/images/watermark/'+this.item.tagId+'/'+obj.min+'@2x.png';
                };
              }
            }

          }
        }




      })
    },
    to_url(path){
      if(path != ""){
        let ios_message = {"method":"openPaper",data:{"to":""+path+""}};
        let android_message = "{\"method\":\"openPaper\",data:{\"to\":\""+path+"\"}}";
        var u = navigator.userAgent, app = navigator.appVersion;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isIOS) {
          window.webkit.messageHandlers.Native.postMessage(ios_message);
        }
        if(isAndroid){
          window.Native.postMessage(android_message);
        }
      }
    },
    timeFormat(param) {
      return param < 10 ? '0' + param : param;
    },
    countdown(){
      let intervalFunc = setInterval(() => {
        let date= new Date();
        let s = date.getSeconds();
        let newTime = new Date().getTime();
        // 对结束时间进行处理渲染到页面
        let endTime = new Date(this.item.activityTime).getTime();
        if((endTime - newTime) < 1){
          window.clearInterval(intervalFunc);
        }else{
          if(s == 59){
            this.getWatermark();
          }
        }


      }, 1000);
    }
  },
  mounted () {
    this.ids = this.$route.query.ids;
    this.w = this.$route.query.w;
    var u = navigator.userAgent, app = navigator.appVersion;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if(isIOS){
      this.w = parseInt(this.w) + 30;
    }
    //this.w = window.screen.width
    this.getWatermark();
    this.countdown();
  }
};



// WEBPACK FOOTER //
// ./src/pages/watermark/watermark.vue